<script lang="ts">
  import { getContext } from 'svelte';

  import Icon from '$shared/atoms/Icon/Icon.svelte';
  import { IconType } from '$shared/constants/IconType';
  import Loader from '$shared/atoms/Loader/Loader.svelte';
  import authService from '$shared/services/authService';
  import Module from '$provider/lib/apis/models/permission/Module';

  const { Actions } = getContext('');

  const ActionClassName = {
    [Actions.Edit]: {
      id: 'edit',
      icon: 'icon-edit-3',
      disabled: !authService.getUserRole().hasWritePermission(Module.Providers)
    },
    [Actions.Remove]: {
      id: 'remove',
      icon: 'icon-trash',
      disabled: !authService.getUserRole().hasWritePermission(Module.Providers)
    },
    [Actions.ReVerify]: {
      id: 'reverify',
      icon: 'icon-rotate-cw',
      disabled: !authService.getUserRole().hasWritePermission(Module.Providers)
    }
  };

  interface Props {
    list?: any;
    loading?: boolean;
    readonly?: boolean;
    onedit?: () => void;
    onremove?: () => void;
    onreverify?: () => void;
  }

  let { list = [], loading = false, readonly = false, onedit, onremove, onreverify }: Props = $props();

  const onClickAction = (item) => {
    if (!ActionClassName[item]) {
      return;
    }
    const id = ActionClassName[item].id;
    if (id === 'edit') onedit?.();
    else if (id === 'remove') onremove?.();
    else if (id === 'reverify') onreverify?.();
  };
</script>

<div class="actions">
  {#if loading}
    <div class="loader">
      <Loader count={1} />
    </div>
  {:else}
    {#each list as item}
      {#if ActionClassName[item]}
        <div class="action">
          <Icon
            name={ActionClassName[item].id}
            value={ActionClassName[item].icon}
            type={IconType.Button}
            disabled={readonly || ActionClassName[item].disabled}
            onclick={() => onClickAction(item)}
          />
        </div>
      {/if}
    {/each}
  {/if}
</div>

<style>
  .loader {
    width: 100px;
  }
  .actions,
  .actions .action {
    display: flex;
    align-items: center;
  }
  .actions .action {
    justify-content: center;
  }
  .actions .action:not(:last-child) {
    margin-right: 8px;
  }
</style>
